import React from 'react';
import { Card, CardContent } from '@/components/ui';

export function ResourceUsage() {
  return (
    <Card className="border-none shadow-sm h-full flex flex-col">
      <CardContent className="p-6 flex-1 flex flex-col">
        <h3 className="text-sm font-bold text-slate-800 mb-6">Sử dụng tài nguyên hệ thống</h3>
        
        <div className="flex-1 space-y-8">
          {/* CPU Usage */}
          <div className="space-y-3">
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-lg bg-emerald-50 flex items-center justify-center">
                  <i className="ri-cpu-line text-emerald-500 text-lg" />
                </div>
                <div>
                  <p className="text-xs font-bold text-slate-700">CPU</p>
                  <p className="text-[10px] text-slate-400">Trung bình</p>
                </div>
              </div>
              <span className="text-sm font-black text-slate-800">23%</span>
            </div>
            <div className="h-1.5 w-full bg-slate-100 rounded-full overflow-hidden">
              <div className="h-full bg-emerald-500 rounded-full" style={{ width: '23%' }} />
            </div>
          </div>

          {/* RAM Usage */}
          <div className="space-y-3">
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-lg bg-blue-50 flex items-center justify-center">
                  <i className="ri-ram-line text-blue-500 text-lg" />
                </div>
                <div>
                  <p className="text-xs font-bold text-slate-700">RAM</p>
                  <p className="text-[10px] text-slate-400">Đã sử dụng 5.2 GB / 16 GB</p>
                </div>
              </div>
              <span className="text-sm font-black text-slate-800">32%</span>
            </div>
            <div className="h-1.5 w-full bg-slate-100 rounded-full overflow-hidden">
              <div className="h-full bg-blue-500 rounded-full" style={{ width: '32%' }} />
            </div>
          </div>

          {/* Disk Usage */}
          <div className="space-y-3">
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-lg bg-orange-50 flex items-center justify-center">
                  <i className="ri-hard-drive-2-line text-orange-500 text-lg" />
                </div>
                <div>
                  <p className="text-xs font-bold text-slate-700">Ổ đĩa</p>
                  <p className="text-[10px] text-slate-400">Đã sử dụng 256.7 GB / 400 GB</p>
                </div>
              </div>
              <span className="text-sm font-black text-slate-800">64%</span>
            </div>
            <div className="h-1.5 w-full bg-slate-100 rounded-full overflow-hidden">
              <div className="h-full bg-orange-500 rounded-full" style={{ width: '64%' }} />
            </div>
          </div>
        </div>

        <div className="mt-6 pt-4 border-t border-slate-50">
          <button className="text-[10px] font-bold text-blue-500 flex items-center gap-1 hover:underline">
            Xem chi tiết hiệu suất <i className="ri-arrow-right-line" />
          </button>
        </div>
      </CardContent>
    </Card>
  );
}
